const MAX_PIN_METADATA_LENGTH = 256;

module.exports = {
  MAX_PIN_METADATA_LENGTH
};
